import _ticker from "./../../levels/common.blocks/ticker/ticker.react.js";

var Ticker = _ticker.applyDecls();

import "./../../levels/common.blocks/ticker/ticker.css";
import "./../../levels/common.blocks/ticker/_state/ticker_state_empty.css";


export default Ticker;